import { datadogLogs } from "@datadog/browser-logs";
import { WidgetAutocheck } from "@redotech/redo-model/widget";
import { log } from "./log";

const MONITORING_SAMPLE_RATE = 1; // in full percent values AKA 100 is 100%
const DATADOG_CLIENT_TOKEN = "pub3ec449fa7d81d7d545ae7eb7690a80f2";

type ErrorContext = {
  error: { message: string; stack?: string; name?: string };
};

const initDatadogLogs = (autocheck: WidgetAutocheck) => {
  datadogLogs.init({
    clientToken: DATADOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    forwardErrorsToLogs: false,
    sessionSampleRate: MONITORING_SAMPLE_RATE,
    service: "redo-shopify-extension",
    env: "production",
  });

  datadogLogs.setGlobalContext({
    autocheck: { teamId: autocheck.teamId },
    ddsource: "browser",
    service: "redo-shopify-extension",
  });
};

export const initEmbedMonitor = ({
  autocheck,
}: {
  autocheck: WidgetAutocheck;
}) => {
  initDatadogLogs(autocheck);

  // TODO: Add other health checks which fire off other logs
};

export const handleAppException = (e_: unknown) => {
  let e: Error;

  if (e_ instanceof Error) {
    e = e_;
  } else {
    e = new Error(String(e_));
  }

  const errorContext: ErrorContext = {
    error: { message: e.message, stack: e.stack, name: e.name },
  };

  datadogLogs.logger.error(errorContext.error.message, errorContext);
  log(errorContext.error.message, errorContext);
};

export const executeAndMonitor = async <T>(
  fn: () => Promise<T>,
): Promise<T | undefined> => {
  try {
    return await fn();
  } catch (e) {
    handleAppException(e);
    return undefined;
  }
};
